export default {
	en: {
		menu: 'MENU',
		listen: 'LISTEN',
		read: 'READ',
		evidence: 'EVIDENCE',
		stories: 'STORIES',
		home: 'HOME',
		about: 'ABOUT',
		resources: 'RESOURCES',
		audio_gallery: 'AUDIO GALLERY',
		tutorial: 'TUTORIAL',
		contact: 'CONTACT',
		read_more: 'Read More',
		footer_text: 'Is a Rise-Home Stories Project. Here are other projects:',
		home_1: 'There’s a scheme happening right under our noses. Black and brown renters are being priced out of their own communities, while vulnerable homeowners are having homes stolen right out from under them. Follow the cases of four courageous residents as they fight to save their homes and communities by getting to the bottom of the intricate web of competing corporate interests, predatory housing policies and practices that enabled their theft. Keep scrolling to help investigate the case against America’s housing market and uncover the perpetrators who have been hiding in plain sight.',
		home_2: 'It’s time to answer the question: “who’s stealing our homes?”',
		home_3: '*This platform throughout uses terms like "crime," "criminal," "steal," and "theft," not to specifically allege that any person or entity broke any law, but instead point to a moral and systemic wrong in the broader sense.',
		villain_text: 'Our suspect is not just one person; it’s a system. From corporate developers to private equity firms to Wall Street landlords, too many bad actors have their hands in the heist to steal our homes. While it may not all look the same or talk the same, the system works with a single goal in mind: to consolidate power and profit at any cost. The culprit(s) behind this long-standing heist want us to believe this is just the way things are - that these instances of predatory action are individual and independent of each other - but that’s not true. Rather, this long-standing scheme is an interconnected web held together by systemic oppression, special interests and harmful policies, allowing developers, financial institutions, and corporations to prey on communities with impunity for years. For too long, the names and institutions at the head of this toxic system have operated with impunity. Read through each of our four cases to see how our courageous protagonists held them accountable, and how you can too.',
		loading: 'Loading story...',
		tutorial_info: {
			title: 'How to use this site',
			step_1: {
				top: '<strong>Keep scrolling</strong> to get to know the story',
				bottom: 'Use the <strong>Next or Previous Exhibit</strong> buttons to navigate different sections of each character\'s story or to return to the beginning.'
			},
			step_2: {
				top: 'Read the <b>descriptions at the top</b> to know more about the story',
				bottom: ''
			},
			step_3: {
				top: 'Use the <b>tape recorder</b> to pause<br />or fast forward the audio story',
				bottom: 'Use the <b>tape recorder</b> to pause and start the audio story'
			},
			step_4: {
				top: '<b>Read more</b> of the story',
				bottom: '<div class="bottom-text-desktop">Explore <b>additional evidence</b><br />about the story</div><div class="bottom-text-mobile"><b>Read more</b> of the story<br />Explore more <b>evidence</b> about the story</div>'
			},
			step_5: {
				top: '<b>Unfold the menu</b><br />to explore more areas',
				bottom: ''
			},
		},
	},
	es: {
		menu: 'MENÚ',
		listen: 'ESCUCHAR',
		read: 'LEER',
		evidence: 'EVIDENCIA',
		stories: 'CUENTOS',
		home: 'HOGAR',
		about: 'ACERCA DE',
		resources: 'RECURSOS',
		audio_gallery: 'GALERÍA DE AUDIOS',
		tutorial: 'TUTORIAL',
		contact: 'CONTACTO',
		read_more: 'Leer más',
		footer_text: 'Es un proyecto de historias de Rise-Home. Aquí hay otros proyectos:',
		home_1: 'Hay un esquema sucediendo justo debajo de nuestras narices. Latinos están siendo excluidos de sus propias comunidades, mientras que a los propietarios vulnerables se les roban las casas justo debajo de ellos. Siga los casos de cuatro valientes residentes mientras luchan por salvar sus hogares y comunidades al llegar al fondo de la intrincada red de intereses corporativos en competencia, políticas de vivienda depredadoras y prácticas que permitieron su robo. Siga avanzando para ayudar a investigar el caso contra el mercado inmobiliario de Estados Unidos y descubra a los perpetradores que se han estado escondiendo a simple vista.',
		home_2: 'Es hora de responder a la pregunta: “¿quién nos está robando las casas?”',
		home_3: '* Esta plataforma utiliza términos como "crimen", "criminal", "robar" y "robo", no para alegar específicamente que cualquier persona o entidad violó alguna ley, sino para señalar un error moral y sistémico en el sentido más amplio.',
		villain_text: 'Nuestro sospechoso no es solo una persona; es un sistema Desde desarrolladores corporativos hasta firmas de capital privado y propietarios de Wall Street, demasiados malos actores tienen sus manos en el atraco para robar nuestras casas. Si bien es posible que no todos se vean o hablen igual, el sistema funciona con un solo objetivo en mente: consolidar el poder y las ganancias a cualquier costo. Los culpables detrás de este atraco que ha existido a largo plazo quieren que creamos que así son las cosas, que estos casos de acción depredadora son individuales e independientes entre sí, pero eso no es cierto. Mas bien este esquema que ha existido por mucho tiempo es una red interconectada que se mantiene unida por la opresión sistémica, los intereses especiales y las políticas dañinas, lo que permite que los desarrolladores, las instituciones financieras y las corporaciones se aprovechen de las comunidades con impunidad por años. Durante demasiado tiempo, los nombres y las instituciones a la cabeza de este sistema tóxico han operado con impunidad. Lea cada uno de nuestros cuatro casos para ver cómo nuestros valientes protagonistas los responsabilizaron y cómo usted también puede hacerlo.',
		loading: 'Cargando historia...',
		tutorial_info: {
			title: 'Cómo usar este sitio',
			step_1: {
				top: '<strong>Sigue desplazándote</strong> para conocer la historia',
				bottom: 'Usa los botones <strong>Siguiente o Exhibición anterior</strong> para navegar por las diferentes secciones de la historia de cada personaje o para volver al principio.'
			},
			step_2: {
				top: 'Lea las <b>descripciones en la parte superior</b> para saber más sobre la historia',
				bottom: ''
			},
			step_3: {
				top: 'Use la <b>grabadora</b> para pausar<br />o avanzar rápidamente la historia de audio',
				bottom: 'Use la <b>grabadora</b> para pausar y comenzar la historia de audio'
			},
			step_4: {
				top: '<b>Leer más</b> de la historia',
				bottom: '<div class="bottom-text-desktop">Explore <b>evidencia adicional</b><br />sobre la historia</div><div class="bottom-text-mobile"><b>Lea más </b> de la historia<br />Explore más <b>evidencia</b> sobre la historia</div>'
			},
			step_5: {
				top: '<b>Despliega el menú</b><br />para explorar más áreas',
				bottom: ''
			},
		},
	},
};
